/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamitemidTypeListValues200,
  GetApiV1ExamExamitemidTypeListValues401,
  GetApiV1ExamExamitemidTypeListValues404,
  GetApiV1ExamExamitemidTypeListValues500,
  GetApiV1ExamExamitemidTypeListValuesPathParams,
  GetApiV1ExamExamitemidTypeListValuesQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidTypeListValues.ts";
import { examTypeListValueEditorViewModelSchema } from "../examTypeListValueEditorViewModelSchema.ts";

export const getApiV1ExamExamitemidTypeListValuesPathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamitemidTypeListValuesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamitemidTypeListValues200Schema = z.array(
  z.lazy(() => examTypeListValueEditorViewModelSchema),
) as unknown as ToZod<GetApiV1ExamExamitemidTypeListValues200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamitemidTypeListValues401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidTypeListValues401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamitemidTypeListValues404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidTypeListValues404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamitemidTypeListValues500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidTypeListValues500>;

export const getApiV1ExamExamitemidTypeListValuesQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamitemidTypeListValues200Schema,
) as unknown as ToZod<GetApiV1ExamExamitemidTypeListValuesQueryResponse>;
